export const REQUESTED_FIELDS = Object.freeze({
  HOUSE_DETAILS: 'HOUSE_DETAILS',
  STRUCTURED_STATUS: 'STRUCTURED_STATUS',
  ACTOR_DETAILS: 'ACTOR_DETAILS',
  FOLLOW_UP: 'FOLLOW_UP',
  TEMP_MIGRATION_SUPPORT: 'TEMP_MIGRATION_SUPPORT',
});
